import React, { useEffect, useState } from 'react';
import { useStore } from '../../store/rootStore';
import InactiveTabModal from '../../components/Chat/common/InactiveTabModal';
import { TEXTERCHAT_HOMEPAGE_URL, USER_STATES } from '../../constants';
const windowId = `${Date.now()}`;
const useHandleInactiveTab = () => {
    const { loginStore, tab, setTabInactive } = useStore();
    const [showModal, setShowModal] = useState(false);
    function close() {
        window.open(TEXTERCHAT_HOMEPAGE_URL, '_self');
    }
    function setActiveWindowId() {
        localStorage.setItem('activeWindowId', windowId);
        setTabInactive(false);
    }
    function storeEventHandler(event) {
        // Only become inactive if another window actively takes over
        if (event.key === 'activeWindowId' && event.newValue !== windowId && event.newValue) {
            setTabInactive(true);
        }
    }
    useEffect(() => {
        window.addEventListener('storage', storeEventHandler);
        return () => {
            window.removeEventListener('storage', storeEventHandler);
        };
    }, []);
    useEffect(() => {
        if (loginStore.userState === USER_STATES.LOGGED_IN) {
            setActiveWindowId();
        }
    }, [loginStore.userState]);
    useEffect(() => {
        if (tab.inactive) {
            // Show modal but DON'T call stopSession immediately
            // Let the modal handle stopSession on timeout/close
            setShowModal(true);
        }
        else {
            setShowModal(false);
        }
    }, [tab.inactive]);
    const handleModalClose = () => {
        // Call stopSession when user explicitly closes or times out
        loginStore.stopSession();
        close();
    };
    return (React.createElement(InactiveTabModal, { visible: showModal, setVisible: setShowModal, setActiveWindowId: setActiveWindowId, close: handleModalClose, withTimeout: true }));
};
export default useHandleInactiveTab;
